package app.nestbridge.feature.careteam.model

import kotlinx.serialization.Serializable

@Serializable
data class CareTeamMember(
    val userId: String,
    val role: TeamRelationshipRole,
)
